import { css as t, styled as o } from "./styled2.mjs";
import { InputLabel as r } from "./index46.mjs";
const s = t`
	color: ${({ theme: e }) => e.deprecated.tokens.stennGrey};
	padding-bottom: 10px;
`, l = o(r)`
	${s}
`;
export {
  l as OverLabel
};
//# sourceMappingURL=styles6.mjs.map
